module.exports = __webpack_public_path__ + "static/media/06.59c0673c.mp3";